import { cn } from '../../../../lib/utils';
import { StatusPillProps } from './interface';

/**
 * A status as a small rounded pill. The label never wraps, so a long one such as
 * "Pending Manager" stays on a single line with the same height, padding and shape
 * as "Pending Scrum" or "Approved", and the row it sits in keeps its height. The
 * colors come from the caller, so every status in a list looks the same but for them.
 *
 * `sizeTo` makes every pill as wide as one chosen label. A zero-height copy of that
 * text sits above the label (a pseudo-element, so it is neither read out nor found as
 * text), which stretches the pill to the same width in any font, and the label is centred in it.
 */
function StatusPill({ label, bg, text, sizeTo, className }: StatusPillProps) {
  return (
    <span
      data-sizer={sizeTo}
      className={cn(
        'inline-flex shrink-0 flex-col items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium',
        'before:invisible before:block before:h-0 before:overflow-hidden before:content-[attr(data-sizer)]',
        bg,
        text,
        className,
      )}
    >
      {label}
    </span>
  );
}

export { StatusPill };
export type { StatusPillProps };
